






















import { Component, Vue } from 'vue-property-decorator'
import { Warning } from '../store/warning'
import Add from './Add.vue'
import Edit from './Edit.vue'
import { namespace } from 'vuex-class'

const warningStore = namespace('warning')

@Component({ components: { Add, Edit } })
export default class Mainwarning extends Vue {
  @warningStore.Action getAll!: () => void
  @warningStore.Getter warnings!: Warning[]
  created() {
    this.getAll()
  }
}
